import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { faTrash } from "@fortawesome/pro-regular-svg-icons";

import { Icon, Modal } from "@/components";
import { ButtonColor } from "@/components/Button/types";

interface DeleteRowModalProps {
	title: string;
	body: string;
	onDelete: () => void;
	/** Offered as the reversible alternative; omitted for rows that cannot be switched off. */
	onDeactivate?: () => void;
	onClose: () => void;
}

/**
 * The "delete permanently?" confirmation (PREC-4055). It always offers
 * "Deactivate instead" where the row supports it, because deleting was the
 * only way to switch anything off before, and that is what the ticket set
 * out to fix.
 */
export const DeleteRowModal: FunctionComponent<DeleteRowModalProps> = ({
	title,
	body,
	onDelete,
	onDeactivate,
	onClose,
}) => {
	const { t } = useTranslation();

	return (
		<Modal
			isOpened
			cancelButtonText={t("basics.cancel")}
			handleClose={onClose}
			handleSave={onDelete}
			handleSecondSave={onDeactivate}
			icon={
				<Icon
					className="mr-1 h-8 w-8 rounded-full bg-status-error-light p-1.5 text-status-error"
					icon={faTrash}
				/>
			}
			secondSubmitButtonText={onDeactivate ? t("leadScoring.detail.deactivateInstead") : undefined}
			size="sm"
			submitButtonColor={ButtonColor.DANGER}
			submitButtonText={t("leadScoring.detail.deletePermanently")}
			title={title}
		>
			<p className="text-sm text-text-meta">{body}</p>
		</Modal>
	);
};
